import React, { useState, useEffect, useMemo } from "react";
import { maxBy } from "lodash";
import axios from "axios";

import { TagTime } from "@aika/types";
import { MiniWidget } from "./MiniWidget";
import { FaHashtag } from "react-icons/fa";
import { DateRange, dateRangeValue } from "components/DateRangeControl";
import { format } from "date-fns";

export const MostPopularTagWidget = ({ range }: { range: DateRange }) => {
  const [data, setData] = useState<TagTime[] | null>(null);
  const [loading, setLoading] = useState(true);

  const text = useMemo(() => {
    if (data == null) return "";

    if (data.length === 0) return "N/A";

    const most = maxBy(data, (x) => x.past_time);
    return `${most.name} - ${most.past_time.toLocaleString()} minutes`;
  }, [data]);

  useEffect(() => {
    setLoading(true);
    const dates = dateRangeValue(range);
    const url = `/api/reports/time-by-tag?start=${format(
      dates[0],
      "yyyy-MM-dd"
    )}&end=${format(dates[1], "yyyy-MM-dd")}`;
    axios.get<TagTime[]>(url).then(({ data }) => {
      setData(data);
      setLoading(false);
    });
  }, [range]);

  return (
    <MiniWidget
      text={text}
      loading={loading}
      title="Most Used Tag"
      icon={FaHashtag}
    />
  );
};
